export const initialState = {
  modalDeleteServiceTributesIsOpen: false,
  modalDeleteServiceTributesIds: [],
};

export default {
  ...initialState,
};
